export const SUPER_USER = "SUPER_USER";
export const STAFF_USER = "STAFF_USER";
export const ACTIVE_USER = "ACTIVE_USER";

export const ROLE = {
  [SUPER_USER]: 1,
  [STAFF_USER]: 2,
  [ACTIVE_USER]: 3,
};
